import { HT_HEADER_LOGO } from './htSheetHeaderImages';
import { HT_FOOTER_IMAGE_ANCHORS } from './htSheetFooterImages';
import htBiosetaLogo from '../../../imagenes/ht-bioseta-logo.png';
import htFirmaTecnico from '../../../imagenes/ht-firma-tecnico.png';
import htIcpIti from '../../../imagenes/ht-icp-iti.png';
import htSelloDigital from '../../../imagenes/ht-sello-digital.png';

/** Proporciones naturales de los PNG HT (px). */
export const HT_BIOSETA_LOGO_ASPECT = 412 / 167;
export const HT_ICP_ITI_ASPECT = 389 / 198;
export const HT_FIRMA_TECNICO_ASPECT = 133 / 138;
export const HT_SELLO_DIGITAL_ASPECT = 255 / 184;

async function imageUrlToDataUrl(url, mimeType = 'image/png') {
  const response = await fetch(url);
  if (!response.ok) throw new Error('No se pudo cargar imagen HT.');
  const bytes = new Uint8Array(await response.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
  return `data:${mimeType};base64,${btoa(binary)}`;
}

export async function addHtSheetImages(ws, wb) {
  const [logo, firma, sello, icp] = await Promise.all([
    imageUrlToDataUrl(htBiosetaLogo),
    imageUrlToDataUrl(htFirmaTecnico),
    imageUrlToDataUrl(htSelloDigital),
    imageUrlToDataUrl(htIcpIti),
  ]);

  const logoId = wb.addImage({ base64: logo, extension: 'png' });
  ws.addImage(logoId, {
    tl: { col: HT_HEADER_LOGO.col, row: HT_HEADER_LOGO.row },
    ext: { width: HT_HEADER_LOGO.width, height: HT_HEADER_LOGO.height },
    editAs: 'oneCell',
  });

  const firmaId = wb.addImage({ base64: firma, extension: 'png' });
  addFooterImage(ws, firmaId, HT_FOOTER_IMAGE_ANCHORS.firma, HT_FIRMA_TECNICO_ASPECT);
  const selloId = wb.addImage({ base64: sello, extension: 'png' });
  addFooterImage(ws, selloId, HT_FOOTER_IMAGE_ANCHORS.sello, HT_SELLO_DIGITAL_ASPECT);
  const icpId = wb.addImage({ base64: icp, extension: 'png' });
  addFooterImage(ws, icpId, HT_FOOTER_IMAGE_ANCHORS.icp, HT_ICP_ITI_ASPECT);
}

function addFooterImage(ws, imageId, anchor, aspect) {
  ws.addImage(imageId, {
    tl: {
      nativeCol: anchor.nativeCol,
      nativeColOff: anchor.nativeColOff,
      nativeRow: anchor.nativeRow,
      nativeRowOff: anchor.nativeRowOff,
    },
    ext: {
      width: anchor.width,
      height: Math.round(anchor.width / aspect),
    },
    editAs: 'oneCell',
  });
}

export { htBiosetaLogo, htFirmaTecnico, htIcpIti, htSelloDigital };
